import React from 'react'
import "../Assets/styles/features.css"
import { IoBulbOutline } from "react-icons/io5";
import { FaMagnifyingGlassChart } from "react-icons/fa6";
import { GrLaunch } from "react-icons/gr";
import { PiPlantLight } from "react-icons/pi";
import { BsGraphUpArrow } from "react-icons/bs";
import { LiaGlassCheersSolid } from "react-icons/lia";

const Features = () => {
  return (
    <>
        <div className="container-lg feature-container">
            <div className="header" data-aos="fade-right" data-aos-duration="1000">
                <span>About</span> 
                <h3>What we offer</h3>
            </div>
            {/* <p>We offer our support through all stages of your product lifecycle.</p> */}
            <div className="small row">
                <div className="object col-lg-4 col-lg-3 col-sm-12" data-aos="fade-up" data-aos-duration="1000">
                    <div className="testings">
                        <div className="cfimage"><IoBulbOutline className='fimage'/></div>
                        <h3>Ideation</h3>
                        <p>We help you refine your ideas into better products</p>
                    </div>
                </div>
                <div className="object col-lg-4 col-md-6 col-sm-12" data-aos="fade-up" data-aos-duration="1000">
                    <div className="testings">
                        <div className="cfimage"><FaMagnifyingGlassChart className='fimage'/></div>
                        <h3>Validation</h3>
                        <p>We assist in the market research for product viability</p>
                    </div>
                </div>
                <div className="object col-lg-4 col-md-6 col-sm-12" data-aos="fade-up" data-aos-duration="1000">
                   <div className="testings">
                    <div className="cfimage"><GrLaunch  className='fimage'/></div>
                        <h3>Launch</h3>
                        <p>We take responsibility for building and launching your product.</p>
                   </div>
                </div>
                <div className="object col-lg-4 col-md-6 col-sm-12" data-aos="fade-up" data-aos-duration="1000">
                    <div className="testings">
                        <div className="cfimage"><PiPlantLight  className='fimage'/></div>
                        <h3>Growth</h3>
                        <p>Scaling operations, increasing customer base, and optimizing processes to achieve sustainable growth and market penetration.</p>
                    </div>
                </div>
                <div className="object col-lg-4 col-md-6 col-sm-12" data-aos="fade-up" data-aos-duration="1000">
                    <div className="testings">
                        <div className="cfimage"><BsGraphUpArrow className='fimage'/></div>
                        <h3>Expansion</h3>
                        <p>Exploring new markets, diversifying product offerings, and expanding operations to capitalize on opportunities and reach a wider audience.</p>
                    </div>
                </div>
                <div className="object col-lg-4 col-md-6 col-sm-12" data-aos="fade-up" data-aos-duration="1000">
                    <div className="testings">
                    <div className="cfimage"><LiaGlassCheersSolid className='fimage'/></div>
                    <h3>Maturity</h3>
                    <p>Support in maintaining market position, optimizing efficiency, and sustaining profitability over the long term</p>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Features